export default "__VITE_ASSET__DlasLdLI__"